module.exports = __webpack_public_path__ + "static/media/export_icon_white.495213aa.svg";